import React from 'react';
import { Box } from '@wix/design-system';
const DEFAULT_PAGE_PADDING = '0';
export const PageLayout = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    children,
    padding = DEFAULT_PAGE_PADDING,
    gap = 0,
    hidden = false
  } = _ref;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, {
    ref: ref,
    align: "center",
    direction: "vertical",
    boxSizing: "border-box",
    verticalAlign: "top",
    minHeight: "100vh",
    height: "100%",
    padding: padding,
    gap: gap,
    zIndex: 2,
    display: hidden ? 'none' : undefined
  }, children));
});
//# sourceMappingURL=PageLayout.js.map